import React, { Fragment, useEffect, useState } from "react";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";

import { actions as discountsActions } from "reducers/discounts";
import { actions as accountsActions } from "reducers/accounts";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";

// eslint-disable-next-line import/no-named-as-default
import EcheqTransactionCard, {
    EcheqTransactionHeader,
    EcheqTransactionSign,
} from "pages/_components/EcheqTransactionCard";
import Button from "pages/_components/Button";

import { useSelector, useDispatch } from "react-redux";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import { Spring, config } from "react-spring";
import { bool, shape } from "prop-types";
import I18n from "pages/_components/I18n";
import ResponsiveHeader from "pages/_components/header";
import * as configUtils from "util/config";

const NewDiscountProcessingTransaction = ({ transaction, isDesktop, isFinished }) => {
    const dispatch = useDispatch();
    const discountTicketSignable = useSelector((_state) => _state.discount?.discountTicketSignable);
    const [showDetails, setShowDetails] = useState(true);
    const account = useSelector((_state) => _state.accounts?.selectedAccount);
    const fetchingAccount = useSelector((_state) => _state.accounts?.fetching);
    const [accountLabel, setAccountLabel] = useState(null);
    const finalEcheqs = transaction?.data?.echeqs || [];
    const isLoading = !transaction?.data || fetchingAccount;
    const isBackoffice = window.self !== window.top;
    const closingHour = configUtils.get("bibank.closingHour", "18");

    const discountData = {
        idTransaction: transaction?.idTransaction || "",

        title: transaction?.activityName,

        solicitante: `${transaction?.userCreatorFirstName} ${transaction?.userCreatorLastName}`,
        montoTotal: transaction?.data?.totalAmount || { quantity: 0, currency: "ARS" },
        montoAcreditar: transaction?.data?.totalEffectiveAmount || { quantity: 0, currency: "ARS" },

        accountId: transaction?.data?.account?.idProduct || "",
        echeqList: transaction?.data?.echeqList || [],

        idBatch: transaction?.data?.idBatch,
    };

    useEffect(() => {
        if (isBackoffice) {
            return;
        }
        if (!account?.accountType && discountData.accountId && !accountLabel) {
            dispatch(accountsActions.readAccount(discountData.accountId));
        } else if (!!account?.accountType && discountData.accountId && !accountLabel) {
            setAccountLabel(
                `${i18n.get(`productType.${account?.accountType}`, "")} ····${account?.accountNumber?.slice(-4)} ${
                    account?.accountType
                } ${i18n.get(`currency.label.${account?.currency}`, "")}` || "Error obteniendo la cuenta",
            );
        }
    }, [dispatch, account, discountData.accountId, accountLabel, setAccountLabel]);

    useEffect(
        () => () => {
            dispatch(discountsActions.cleanDiscountTicket());
        },
        [],
    );

    const handleSignTransaction = () => {
        // const discountDetails = { ...transaction?.data?.discount, idTransaction: transaction?.idTransaction };
        // dispatch(discountsActions.setNewDiscountData(discountDetails, transaction?.data?.token));
        dispatch(routerActions.push("/discounts/summaryForm"));
    };

    return (
        <Fragment>
            <Notification scopeToShow="discounts" />
            {!isBackoffice && (
                <ResponsiveHeader ticket id="echeq.discount.request" metaTitle="echeq.discount.request" />
            )}
            <MainContainer showLoader={isLoading}>
                <EcheqTransactionCard transaction={transaction}>
                    <EcheqTransactionHeader
                        title={discountData.title}
                        subTitle={i18n.get("", "Operación enviada para aprobación")}
                    />
                    <div className="ticket__wrapper">
                        <div className="ticket__header" />
                        <div className="ticket__body refills-transaction">
                            <div className="ticket-header-info" style={{ gap: "25px" }}>
                                <CustomData
                                    titleText={i18n.get("", "Solicitante")}
                                    valueText={discountData.solicitante}
                                />
                                <CustomData
                                    titleText={i18n.get("echecks.amount", "Monto total")}
                                    valueText={discountData.montoTotal.quantity}
                                    valueTextType={discountData.montoTotal.currency}
                                />
                                <CustomData
                                    dataClass="amount tag tag-echeq-character"
                                    titleText={`${i18n.get(
                                        "detail.discounts.totalEffectiveAmount",
                                        "Monto a acreditar",
                                    )}`}
                                    valueText={discountData.montoAcreditar.quantity}
                                    valueTextType={discountData.montoAcreditar.currency}
                                />
                            </div>
                            <div className="view-more-data-button" id="element-to-ignore">
                                <div className="ticket__divider inside-ticket__body">
                                    <div className="ticket__notch ticket__notch--left"> </div>
                                    <div className="ticket__notch ticket__notch--right"> </div>
                                </div>
                                <Button
                                    image={
                                        showDetails
                                            ? "images/figma/icon/arrow-up.svg"
                                            : "images/figma/icon/arrow-down.svg"
                                    }
                                    onClick={() => setShowDetails((v) => !v)}
                                    label={showDetails ? "transfers.showLess" : "transfers.showMore"}
                                    className="btn btn-link open-filters d-flex margin-cero-auto"
                                    block={false}
                                />
                                <Spring
                                    config={config.stiff}
                                    from={{ height: 0 }}
                                    to={{
                                        height: showDetails ? "auto" : 0,
                                        overflow: "hidden",
                                    }}>
                                    {(styles) => (
                                        <div className="form-group" style={styles}>
                                            <div className="form-group-control-list">
                                                <I18n id="creditBill.aditionalData.label" component="h2" />
                                                <div
                                                    className={`view-more-data ${
                                                        showDetails ? "expand " : "collapse"
                                                    } pt-4`}>
                                                    <CustomData
                                                        titleText="detail.discounts.creditAccount"
                                                        titleTextType="I18N"
                                                        valueText={accountLabel}
                                                    />
                                                    <CustomData
                                                        titleText="echeq.request.amount.label"
                                                        titleTextType="I18N"
                                                        valueText={finalEcheqs.length}
                                                    />
                                                    <CustomData
                                                        titleText="echecks.echeckLotId"
                                                        titleTextType="I18N"
                                                        valueText={discountData.idBatch}
                                                    />
                                                </div>
                                            </div>
                                            <div className="ticket__divider inside-ticket__body">
                                                <div className="ticket__notch ticket__notch--left"> </div>
                                                <div className="ticket__notch ticket__notch--right"> </div>
                                            </div>
                                        </div>
                                    )}
                                </Spring>
                            </div>
                            <div
                                className={`view-more-data view-discounts-echeq ${
                                    showDetails ? "expand " : "collapse"
                                }`}>
                                <I18n id="documentBatch" component="h2" />

                                <GridTable>
                                    {isDesktop && (
                                        <GridTable.Container columns={5} rows={1} className="received-from">
                                            <GridTable.Data columnStart={1} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts"
                                                    text={i18n.get("", "Recibido de")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={2} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts"
                                                    text={i18n.get("", "ID Echeq")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={3} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts"
                                                    text={i18n.get("", "Emisión")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={4} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts"
                                                    text={i18n.get("", "Vencimiento")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={5} rowStart={1}>
                                                <CustomText className="title-discounts" text={i18n.get("", "Monto")} />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    )}
                                    <Spring
                                        config={config.stiff}
                                        from={{ height: 0 }}
                                        to={{
                                            height: finalEcheqs.length ? "auto" : 0,
                                            overflow: "hidden",
                                        }}>
                                        {(styles) => (
                                            <div className="form-group" style={styles}>
                                                <div className="form-group-control-list">
                                                    {finalEcheqs.map((echeq, index) => (
                                                        <GridTable.Container
                                                            columns={5}
                                                            rows={1}
                                                            className="received-from data-echeq"
                                                            key={index}>
                                                            <GridTable.Data
                                                                columnStart={1}
                                                                rowStart={1}
                                                                flexDirection="column">
                                                                {isDesktop ? (
                                                                    <>
                                                                        <CustomText
                                                                            text={`CUIT ${echeq.emisor_cuit}`}
                                                                        />
                                                                        <CustomText
                                                                            text={`${echeq.emisor_razon_social}`}
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.recibedTo"
                                                                        titleTextType="I18N"
                                                                        valueText={
                                                                            <>
                                                                                <CustomText
                                                                                    text={`CUIT ${echeq.emisor_cuit}`}
                                                                                />
                                                                                <br />
                                                                                <CustomText
                                                                                    text={echeq.emisor_razon_social}
                                                                                />
                                                                            </>
                                                                        }
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={2} rowStart={1}>
                                                                {isDesktop ? (
                                                                    <CustomText text={echeq.cheque_numero} />
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.echek.id"
                                                                        titleTextType="I18N"
                                                                        valueText={echeq.cheque_numero}
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={3} rowStart={1}>
                                                                {isDesktop ? (
                                                                    <CustomText
                                                                        text={echeq.fecha_emision}
                                                                        textType="DATE"
                                                                    />
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.emitter"
                                                                        titleTextType="I18N"
                                                                        valueText={echeq.fecha_emision}
                                                                        textType="DATE"
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={4} rowStart={1}>
                                                                {isDesktop ? (
                                                                    <CustomText
                                                                        text={echeq.fecha_pago}
                                                                        textType="DATE"
                                                                    />
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.dudate"
                                                                        titleTextType="I18N"
                                                                        valueText={echeq.fecha_pago}
                                                                        textType="DATE"
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={5} rowStart={1}>
                                                                {isDesktop ? (
                                                                    <CustomText
                                                                        text={echeq.monto}
                                                                        textType={echeq.emisor_moneda}
                                                                    />
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.amount"
                                                                        titleTextType="I18N"
                                                                        valueText={echeq.monto}
                                                                        valueTextType={echeq.emisor_moneda}
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            {index !== finalEcheqs.length - 1 && !isDesktop && (
                                                                <div className="ticket__divider inside-ticket__body">
                                                                    <div className="ticket__notch ticket__notch--left" />
                                                                    <div className="ticket__notch ticket__notch--right" />
                                                                </div>
                                                            )}
                                                        </GridTable.Container>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </Spring>
                                </GridTable>
                            </div>
                            <div className={`view-more-data ${showDetails ? "expand " : "collapse"}`}>
                                <EcheqTransactionSign
                                    isSmall
                                    customText={isFinished && "forms.transaction.ticket.dateAndHour"}
                                    creationTime
                                    hasSignatures
                                    isDesktop={isDesktop}
                                    noDate={!isFinished}
                                />
                            </div>
                            {/* <TransactionSign
                                isSmall
                                customText={isFinished && "forms.transaction.ticket.dateAndHour"}
                                creationTime
                                hasSignatures
                                isDesktop={isDesktop}
                                noDate={!isFinished}
                            /> */}
                        </div>
                        <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                    </div>
                </EcheqTransactionCard>

                <div className="box info border">
                    <CustomData
                        keepSpaceIfNoValue={false}
                        icon="images/figma/icon/info.svg"
                        titleText={i18n.get(
                            "",
                            `La solicitud se encontrará sujeta a aprobación crediticia de Bibank y tendrá
                            vigencia hasta las ${closingHour}:00 horas.
                            Vencido dicho plazo sin haber sido aceptada o rechazada por Bibank, deberá generarse nuevamente.`,
                        )}
                    />
                </div>

                {/* <div className="discounts-echeq-simulation__rate">
                    <CustomText
                        text={`* ${i18n.get(
                            "discounts.amountToCredit.disclaimer",
                            "Monto a acreditar sujeto a impuesto de sellos e IIBB.",
                        )}`}
                    />
                </div> */}

                {!isBackoffice && (
                    <Row className="form-actions">
                        <Col xs={12} md={4} mdOffset={discountTicketSignable ? 2 : 4}>
                            <CustomButton
                                func={() => dispatch(routerActions.push("/desktop"))}
                                text="forms.transaction.ticket.actions.backToHome"
                                textType="I18N"
                                className={`btn${discountTicketSignable ? " btn-outline" : " btn-primary"}`}
                            />
                        </Col>
                        {discountTicketSignable && (
                            <Col xs={12} md={4}>
                                <CustomButton
                                    func={handleSignTransaction}
                                    text="forms.signTransaction.link"
                                    textType="I18N"
                                    className="btn btn-primary"
                                />
                            </Col>
                        )}
                    </Row>
                )}
            </MainContainer>
        </Fragment>
    );
};

NewDiscountProcessingTransaction.propTypes = {
    transaction: shape({}).isRequired,
    isDesktop: bool.isRequired,
    isFinished: bool.isRequired,
};

export default NewDiscountProcessingTransaction;
